import { get, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationUpcomingEvents = get('reservation.upcomingEvents');

export const getAll = createSelector(getReservationUpcomingEvents, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getOrderedUpcoming = createSelector(
  getAllValues,
  orderBy('id', 'desc')
);

export const getOrder = createSelector(
  getReservationUpcomingEvents,
  get('order')
);

export const getIsFetching = createSelector(
  getReservationUpcomingEvents,
  get('fetching')
);
export const getIsFetched = createSelector(
  getReservationUpcomingEvents,
  get('fetched')
);

export const getFetchingError = createSelector(
  getReservationUpcomingEvents,
  get('fetchingError')
);
